import axios from '../../../apis/Api'
import history, { logout } from '../../../history'
import storage from '../../../apis/Storage'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import { GET_DIST_COINS_DISBURSEMENT_REPORT } from '../../../Types'
import fileSaver from 'file-saver'
import * as XLSX from 'xlsx'

export const getDistributorCoinsDisbursementReport = (requestData) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post(`api/VLPLedger/GetDistributorCoinsDisbursementReport`, requestData)
    .then(({ data }) => {
      if (data && data?.response)
        dispatch({
          type: GET_DIST_COINS_DISBURSEMENT_REPORT,
          payload: data.response,
        })
      dispatch(hideLoading())
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data) toast.error(error.response.data.Message ? error.response.data.Message : error.response.data.message)
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const resetRsoDetailsReport = () => async (dispatch) => {
  // dispatch({
  //   type: RESET_RSO_DETAILS_REPORT,
  //   payload: [],
  // })
}

export const downloadJob = (requestData) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post(`api/VLPLedger/GetDistributorCoinsDisbursementReport`, requestData)
    .then(({ data }) => {
      const outputFilename = `Distributor_Coins_Disbursement_Report_${Date.now()}`
      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      const fileExtension = '.xlsx'

      const exportToCSV = (csvData, jobNumber, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData)
        if (ws) {
          var range = XLSX.utils.decode_range(ws['!ref'])
          for (var C = range.s.c; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + '1' // <-- first row, column number C
            if (!ws[address]) continue
            ws[address].v =
              ws[address].v == 'distributorName'
                ? 'Distributor Name'
                : ws[address].v == 'distributionCenterName'
                  ? 'Distribution Center Name'
                  : ws[address].v == 'date'
                    ? 'Date'
                    : ws[address].v == 'invoiceTotals'
                      ? 'Invoice Value (Rupees)'
                      : ws[address].v == 'walletPayments'
                        ? 'Total Digital Payment (Jazz + EP)'
                        : ws[address].v == 'coinsDisbursed'
                          ? 'Total Coins Disbursement'
                          : ws[address].v
          }
        }
        // var sheetName = `Job_Number_${jobNumber}`
        const wb = {
          Sheets: { data: ws },
          SheetNames: [`data`],
        }
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const fileData = new Blob([excelBuffer], { type: fileType })
        fileSaver.saveAs(fileData, fileName + fileExtension)
      }
      exportToCSV(data?.response?.dataList, '', outputFilename)
      dispatch(hideLoading())
    })

    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data) toast.error(error.response.data.Message ? error.response.data.Message : error.response.data.message)
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}
